import { paymentTypes } from 'shared/helpers/constants/payments/paymentTypes';
import { REQUEST_PAYMENT } from 'shared/helpers/constants/payments/requestPaymentConstants';
import { isHedgeNotRequired } from 'shared/helpers/matchers/companies/checkExceptionType';
import { replaceEmpty, removeCommasAndParse } from 'shared/helpers/parsers/text';
import { commaValidator } from 'shared/helpers/validations/commaValidator';
import { PRICE_REGEX } from 'shared/helpers/validations/regularExpressions';

import dateAdapter from 'utils/date/dateAdapter';
import { MomentAdapter } from 'utils/date/momentAdapter';

function validate(values, props) {
  const paymentAmount = props.paymentAmount && props.paymentAmount.data;
  const exceptionTypes = paymentAmount?.paymentExceptionCompany?.exceptionTypes || [];

  const errors = {};

  if (!values.relatedCompany) {
    errors.relatedCompany = REQUEST_PAYMENT.RELATED_COMPANY_EMPTY;
  }

  if (!values.relatedLot) {
    errors.relatedLot = REQUEST_PAYMENT.RELATED_LOT_EMPTY;
  }

  if (!values.paymentType) {
    errors.paymentType = REQUEST_PAYMENT.PAYMENT_TYPE_EMPTY;
  }

  if (!values.requestedFinalPaymentDate) {
    errors.requestedFinalPaymentDate = REQUEST_PAYMENT.REQUESTED_FINAL_PAYMENT_DATE_EMPTY;
  }

  if (
    !values.isDraftPoolPayment &&
    dateAdapter(values.requestedFinalPaymentDate).isBefore(
      new MomentAdapter().subtract(1, 'd').startOf('d'),
    )
  ) {
    errors.requestedFinalPaymentDate = REQUEST_PAYMENT.REQUESTED_FINAL_PAYMENT_DATE_TOO_LOW;
  }

  if (!values.fundsType) {
    errors.fundsType = REQUEST_PAYMENT.FUNDS_TYPE_EMPTY;
  }

  if (values.additionalInfo && values.additionalInfo.length > 250) {
    errors.additionalInfo = REQUEST_PAYMENT.ADDITIONAL_INFO_INVALID;
  }

  if (replaceEmpty(values.paymentAmount, '').length === 0) {
    errors.paymentAmount = REQUEST_PAYMENT.PAYMENT_AMOUNT_EMPTY;
  } else if (!PRICE_REGEX.test(values.paymentAmount)) {
    errors.paymentAmount = REQUEST_PAYMENT.PAYMENT_AMOUNT_INVALID;
  } else if (values.paymentAmount && values.paymentAmount.toString().length > 12) {
    errors.paymentAmount = REQUEST_PAYMENT.PAYMENT_AMOUNT_INVALID;
  } else if (removeCommasAndParse(values.paymentAmount) <= 0) {
    errors.paymentAmount = REQUEST_PAYMENT.PAYMENT_AMOUNT_NEGATIVE;
  } else if (
    values.paymentType &&
    values.paymentType.value === paymentTypes.advance &&
    removeCommasAndParse(values.paymentAmount) >
      removeCommasAndParse(paymentAmount.availableAmount) &&
    !isHedgeNotRequired(exceptionTypes)
  ) {
    errors.paymentAmount = REQUEST_PAYMENT.PAYMENT_AMOUNT_TOO_HIGH;
  }

  commaValidator({ paymentAmount: values.paymentAmount }, errors);

  return errors;
}

export { validate };
